var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8052_98374",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8052_98374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3823 16.6364C5.95914 16.6364 5.59772 16.4937 5.29804 16.2085C4.99834 15.9232 4.84849 15.5792 4.84849 15.1764V4.92584H4V3.71442H7.81817V3H12.9091V3.71442H16.7273V4.92584H15.8788V15.1764C15.8788 15.5844 15.7303 15.9297 15.4333 16.2124C15.1364 16.495 14.7736 16.6364 14.345 16.6364H6.3823ZM14.6061 4.92584H6.1212V15.1764C6.1212 15.2489 6.14568 15.3085 6.19463 15.3551C6.24359 15.4017 6.30615 15.4249 6.3823 15.4249H14.345C14.4102 15.4249 14.4701 15.3991 14.5245 15.3473C14.5789 15.2955 14.6061 15.2386 14.6061 15.1764V4.92584Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIc);
export default __webpack_public_path__ + "static/media/delete_ic.184d60f0561c775052a88012a050d684.svg";
export { ForwardRef as ReactComponent };